import { render, staticRenderFns } from "./ListPosicaoMotoristaView.vue?vue&type=template&id=6c04f8f6&"
import script from "./ListPosicaoMotoristaView.vue?vue&type=script&lang=ts&"
export * from "./ListPosicaoMotoristaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports